import { Component, OnInit } from '@angular/core';
import { OpenService } from '@app-services/open.service';

@Component({
  selector: '[app-card-vehicle-loader]',
  templateUrl: './card-vehicle-loader.component.html',
  styleUrls: ['./card-vehicle-loader.component.scss']
})
export class CardVehicleLoaderComponent implements OnInit {

  constructor(
    openService: OpenService
  ) { }

  ngOnInit() {
  }

}
